module.exports = __webpack_public_path__ + "static/media/promo_2024_july_aug_mobile_468.119506d4.jpg";